import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ImageBlockComponent from "../nodeviews/ImageBlockComponent";

const ImageBlock = Node.create({
    name: "imageBlock",

    group: "block",
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
        return {
            images: {
                default: [],
                parseHTML: element => {
                    const data = element.getAttribute("data-images");
                    try {
                        return data ? JSON.parse(data) : [];
                    } catch (e) {
                        return [];
                    }
                },
                renderHTML: attributes => {
                    return {
                        "data-images": JSON.stringify(attributes.images || []),
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "div[data-type='image-block']",
                getAttrs: dom => {
                    const data = dom.getAttribute("data-images");
                    try {
                        return {
                            images: data ? JSON.parse(data) : [],
                        };
                    } catch (e) {
                        return { images: [] };
                    }
                },
            },
        ];
    },

    renderHTML({ node }) {
        const images = node.attrs.images || [];

        return [
            "div",
            {
                "data-type": "image-block",
                "data-images": JSON.stringify(images),
            },

            ...images.flatMap(img => {
                const elements = [
                    ["figure", { class: "image-item" }, ["img", { src: img.url || "", alt: img.label || "" }]]
                ];

                if (img.label) {
                    elements[0].push(["figcaption", {}, img.label]);
                }
                if (img.description) {
                    elements[0].push(["p", { class: "image-desc" }, img.description]);
                }

                return elements;
            })
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ImageBlockComponent);
    },
});

export default ImageBlock;